import { Divider } from 'components/commons/Divider'
import Footer from 'components/layouts/Footer'
import Page from 'components/Page'
import { GetStaticProps } from 'next'

import Layout from 'components/layouts/Layout'
import { useTranslations } from 'next-intl'
import { ReactElement } from 'react'

function PrivacyPolicy() {

  const t = useTranslations("politica-de-privacidade")

  return (
    <Page id='privacy-policy' title={t("metadata-title")} description={t("metadata-description")} className='bg-gray' footer>
      <div className='w-full mx-auto max-w-6xl'>
        <div className='w-full text-center mb-12'>
          <h1 className='text-7xl md:text-10xl font-bold md:font-extrabold mb-6 text-center'>
            {t("title")}
          </h1>
          <Divider />
        </div>

        <p>{t("summary-1")}</p>
        <p>{t("summary-2")}</p>
        <p>{t("summary-3")}</p>
        <p>{t("summary-4")}</p>

        <p className='text-4xl font-semibold mt-6'>{t("collected-information-title")}</p>
        <p>{t("collected-information-1")}</p>

        <p className='text-4xl font-semibold mt-6'>{t("how-data-is-collected-title")}</p>
        <p>{t("how-data-is-collected-1")}</p>
        <p>{t("how-data-is-collected-2")}</p>
        <p>- {t("how-data-is-collected-3")}</p>
        <p>- {t("how-data-is-collected-4")}</p>
        <p>- {t("how-data-is-collected-5")}</p>
        <p>- {t("how-data-is-collected-6")}</p>
        <p>- {t("how-data-is-collected-7")}</p>

        <p className='text-4xl font-semibold mt-6'>{t("how-data-is-treated-title")}</p>
        <p>{t("how-data-is-treated-1")}</p>
        <p>{t("how-data-is-treated-2")}</p>
        <p>{t("how-data-is-treated-3")}</p>
        <p>{t("how-data-is-treated-4")}</p>

        <p className='text-4xl font-semibold mt-6'>{t("how-we-communicate-with-our-customers-title")}</p>
        <p>{t("how-we-communicate-with-our-customers-1")}</p>

        <p className='text-4xl font-semibold mt-6'>{t("how-you-revoke-the-consent-title")}</p>
        <p>{t("how-you-revoke-the-consent-1")}</p>
        <p>{t("how-you-revoke-the-consent-2")}</p>

      </div>
    </Page>
  )
}

export const getStaticProps: GetStaticProps = async context => {
  return {
    props: {
      context,
      messages: (await import(`../lang/${context.locale}.json`)).default
    }
  }
}

PrivacyPolicy.getLayout = function getLayout(page: ReactElement) {
  return (
    <Layout variant='secondary'>
      {page}
    </Layout>
  )
}

export default PrivacyPolicy
